import CalculatorsController from '../../src/javascripts/cvm';
import RadarFirstRoi from '../../src/javascripts/models/radar_first/roi';
import RadarFirstMarketoHelper from '../../src/javascripts/helpers/radar_first/marketo_helper';
import '../../src/stylesheets/radar_first/roi.scss';

(function() {
  $(() => CalculatorsController.run(new RadarFirstRoi()));
}).call(this);

$(() => {
  const marketo_helper = new RadarFirstMarketoHelper();
  marketo_helper.run();
});
